import { gql } from '@apollo/client';

export interface CreateCarpoolTripMutation {
  createCarpoolTrip: {
    id: string;
  };
}

export interface CreateCarpoolTripMutationVariables {
  createCarpoolTripInput: {
    eventId: string;
    pickupExactLocation: string;
    pickupTown: string;
    pickupAt: Date;
    seats: number;
    description?: string | null;
  };
}

export const CREATE_CARPOOL_TRIP = gql`
  mutation CreateCarpoolTrip($createCarpoolTripInput: CreateCarpoolTripInput!) {
    createCarpoolTrip(createCarpoolTripInput: $createCarpoolTripInput) {
      id
    }
  }
`;
